export const propertyTypeTranslations = {
  residence: 'Domicílio',
  commerce: 'Comércio',
  vacantLand: 'Terreno baldio',
  school: 'Escola',
  dayCare: 'Creche',
  shelter: 'Abrigo',
  longTermFacilityForElderly: 'Instituição de longa permanência para idosos',
  prisonUnit: 'Unidade prisional',
  socioEducativeMeasureUnit: 'Unidade de medida sócio educativa',
  policeStation: 'Delegacia',
  religiousEstablishment: 'Estabelecimento religioso',
  others: 'Outros',
  strategicPoint:
    'Ponto Estratégico (cemitério, borracharia, ferro-velho, depósito de sucata ou materiais de construção, garagem de ônibus ou veículo de grande porte)',
} as const

export const locationTypeTranslations = {
  notInformed: 'Não informado',
  urban: 'Urbana',
  rural: 'Rural',
} as const

export const houseTypeTranslations = {
  notInformed: 'Não informado',
  house: 'Casa',
  apartment: 'Apartamento',
  room: 'Cômodo',
  other: 'Outro',
} as const

export const housingSituationTranslations = {
  notInformed: 'Não informado',
  owned: 'Próprio',
  financed: 'Financiado',
  rented: 'Alugado',
  leased: 'Arrendado',
  granted: 'Cedido',
  occupation: 'Ocupação',
  streetSituation: 'Situação de rua',
  invasion: 'Invasão',
  other: 'Outra',
} as const

export const landPossessionTypeTranslations = {
  notInformed: 'Não informado',
  owner: 'Proprietário',
  partnerOrSharecropper: 'Parceiro(a) / Meeiro(a)',
  settled: 'Assentado(a)',
  squatter: 'Posseiro',
  leaseholder: 'Arrendatário(a)',
  loanRecipient: 'Comodatário(a)',
  landBankBeneficiary: 'Beneficiário(a) do Banco da Terra',
  notApplicable: 'Não se aplica',
} as const

export const houseAccessTypeTranslations = {
  notInformed: 'Não informado',
  paved: 'Pavimento',
  dirtRoad: 'Chão batido',
  fluvial: 'Fluvial',
  other: 'Outro',
} as const

export const wallMaterialTypeTranslations = {
  notInformed: 'Não informado',
  masonryWithCoating: 'Alvenaria com revestimento',
  masonryWithoutCoating: 'Alvenaria sem revestimento',
  mudWallWithCoating: 'Taipa com revestimento',
  mudWallWithoutCoating: 'Taipa sem revestimento',
  planedWood: 'Madeira aparelhada',
  recycledMaterial: 'Material aproveitado',
  straw: 'Palha',
  otherMaterial: 'Outro material',
} as const

export const waterSupplyTypeTranslations = {
  notInformed: 'Não informado',
  pipedWater: 'Rede encanada até o domicílio',
  wellOrSpring: 'Poço / Nascente no domicílio',
  cistern: 'Cisterna',
  waterTruck: 'Carro pipa',
  other: 'Outro',
  pipedWaterFromVillageSystem:
    'Rede encanada até o domicílio - Sistema de abastecimento próprio da aldeia (SESAI)',
  directRiverIntake: 'Captação direta de água do rio',
  directCollectiveWellIntake: 'Captação direta de poço coletivo',
  publicFountain: 'Ponto de abastecimento coletivo - chafariz',
} as const

export const waterTreatmentTypeTranslations = {
  notInformed: 'Não informado',
  filtered: 'Filtração',
  boiled: 'Fervura',
  chlorinated: 'Cloração',
  mineral: 'Mineral',
  noTreatment: 'Sem tratamento',
  other: '(Outro)',
  filteredClay: 'Filtrada com filtro de barro',
  filteredOther: 'Filtrada por outro tipo de filtro',
  inHouseChlorination: 'Clorada intradomiciliar com hipoclorito de sódio',
} as const

export const sanitationTypeTranslations = {
  notInformed: 'Não informado',
  sewerOrStormwaterCollectionNetwork: 'Rede coletora de esgoto ou pluvial',
  septicTank: 'Fossa séptica',
  rudimentaryPit: 'Fossa rudimentar',
  directToRiverLakeOrSea: 'Direto para um rio, lago ou mar',
  openAir: 'Céu aberto',
  other: 'Outra forma',
} as const

export const garbageDisposalTypeTranslations = {
  notInformed: 'Não informado',
  collected: 'Coletado',
  burnedOrBuried: 'Queimado / Enterrado',
  openAir: 'Céu aberto',
  other: 'Outro',
} as const
